export default "__VITE_ASSET__oz0EGbNd__"